import SalesBackground1 from './assets/dashboard-sales-card-background-1.svg';
import SalesBackground2 from './assets/dashboard-sales-card-background-2.svg';
import SalesBackground3 from './assets/dashboard-sales-card-background-3.svg';
import { getClubSalesPost } from './helpers';

const HOTMART_BLOG = 'https://blog.hotmart.com/';

const HOTMART_BLOG_API = `${HOTMART_BLOG}wp-json/wp/v2/`;

const BLOG_LANGUAGES = {
  pt: 'pt-br',
  es: 'es',
  ar: 'ar',
  en: 'en',
  fr: 'fr'
};

const FAQ_LANGUAGES = {
  ar: 'ar',
  en: 'en',
  es: 'es',
  fr: 'fr',
  it: 'it',
  pt: 'pt'
};

const MEMBERS_AREA_POST_ID = {
  pt: 85067,
  es: 86512,
  en: 86531,
  fr: 86638
};

const STATIC_LINKS = {
  HOTMART_FAQ: {
    ar: 'https://atendimento.hotmart.com.br/hc/ar/sections/360008260532-Hotmart-Club',
    en: 'https://atendimento.hotmart.com.br/hc/en-us/sections/360008260532-Members-Area-Hotmart-Club-',
    es: 'https://atendimento.hotmart.com.br/hc/es-es/sections/360008260532-%C3%81rea-de-Miembros-Hotmart-Club-',
    fr: 'https://atendimento.hotmart.com.br/hc/fr/sections/360008260532-Hotmart-Club',
    it: 'https://atendimento.hotmart.com.br/hc/it/sections/360008260532-Area-di-Membri-Hotmart-Club-',
    pt: 'https://atendimento.hotmart.com.br/hc/pt-br/sections/360008260532-%C3%81rea-de-Membros-Hotmart-Club-'
  },
  CONTENT_MODULE: {
    es: 'https://atendimento.hotmart.com.br/hc/es-es/articles/207922148--Qu%C3%A9-tipo-de-contenido-puedo-adicionar-a-una-clase-',
    pt: 'https://atendimento.hotmart.com.br/hc/pt-br/articles/207922148-Que-tipo-de-conte%C3%BAdo-eu-posso-adicionar-a-uma-aula-'
  },
  EXTRA_MODULE: {
    en: 'https://atendimento.hotmart.com.br/hc/en-us/articles/360000645592-How-to-create-an-extra-paid-module-on-Hotmart-Club-',
    es: 'https://atendimento.hotmart.com.br/hc/es-es/articles/360000645592--C%C3%B3mo-crear-un-m%C3%B3dulo-adicional-pago-en-el-Hotmart-Club-',
    fr: 'https://atendimento.hotmart.com.br/hc/fr/articles/360000645592-Comment-cr%C3%A9er-des-modules-suppl%C3%A9mentaires-gratuits-et-payants-dans-Hotmart-Club-',
    pt: 'https://atendimento.hotmart.com.br/hc/pt-br/articles/360000645592-Como-criar-m%C3%B3dulos-extras-gratuitos-e-pagos-no-Hotmart-Club-'
  },
  HOTMART_BLOG,
  HOTMART_BLOG_CLUB_SALES: {
    pt: `${HOTMART_BLOG}pt-br/club-sales-e-modulos-extras-pagos/`,
    es: `${HOTMART_BLOG}es/club-sales-y-modulos-adicionales-pagos-la-pareja-perfecta/`,
    en: `${HOTMART_BLOG}en/club-sales-and-extra-paid-modules/`,
    fr: `${HOTMART_BLOG}fr/club-sales-et-modules-extras-payants-le-duo-parfait-pour-qui-produit-et-vend-du-contenu/`
  },
  HOTMART_BLOG_API: `${HOTMART_BLOG}`,
  // TODO: Replace with actual links
  PUBLISH_AND_NOTIFY: {
    ar: 'https://atendimento.hotmart.com.br/hc/ar/articles/4410825187341',
    en: 'https://atendimento.hotmart.com.br/hc/en/articles/4410825187341',
    es: 'https://atendimento.hotmart.com.br/hc/es/articles/4410825187341',
    de: 'https://atendimento.hotmart.com.br/hc/de/articles/4410825187341',
    fr: 'https://atendimento.hotmart.com.br/hc/fr/articles/4410825187341',
    it: 'https://atendimento.hotmart.com.br/hc/it/articles/4410825187341',
    ja: 'https://atendimento.hotmart.com.br/hc/ja/articles/4410825187341',
    pt: 'https://atendimento.hotmart.com.br/hc/pt-br/articles/4410825187341'
  },
  // TODO: Replace with the correct links
  DRM_COMPATIBLE_DEVICES: {
    ar: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341',
    en: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341',
    es: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341',
    fr: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341',
    it: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341',
    pt: 'https://atendimento.hotmart.com.br/hc/articles/4410825187341'
  }
};

const SALES_BANNER_STEPS = {
  MAKE_SALES: 'MAKE_SALES',
  MAKE_YOUR_FIRST_SALE: 'MAKE_YOUR_FIRST_SALE',
  CONGRATULATION_YOU_SOLD: 'CONGRATULATION_YOU_SOLD',
  YOU_MADE_NUMBER_SALES: 'YOU_MADE_NUMBER_SALES',
  CONGRATULATION_YOU_NUMBER_SALES: 'CONGRATULATION_YOU_NUMBER_SALES'
};

const SALES_BANNER = {
  [SALES_BANNER_STEPS.MAKE_SALES]: {
    title: 'dashboard.make_sales_card.title',
    description: 'dashboard.make_sales_card.description',
    buttonText: 'dashboard.make_sales_card.button_text',
    imageSrc: SalesBackground1,
    getExternalLink: (shortLocale) => getClubSalesPost(shortLocale)
  },
  [SALES_BANNER_STEPS.MAKE_YOUR_FIRST_SALE]: {
    title: 'dashboard.make_your_first_sale.title',
    description: 'dashboard.make_your_first_sale.description',
    buttonText: 'dashboard.make_sales_card.button_text',
    imageSrc: SalesBackground2
  },
  [SALES_BANNER_STEPS.CONGRATULATION_YOU_SOLD]: {
    title: 'dashboard.congratulation_you_sold.title',
    description: 'dashboard.congratulation_you_sold.description',
    buttonText: 'dashboard.congratulation_you_sold.button_text',
    imageSrc: SalesBackground3
  },
  [SALES_BANNER_STEPS.YOU_MADE_NUMBER_SALES]: {
    title: 'dashboard.you_made_number_sales.title',
    description: 'dashboard.congratulation_you_sold.description',
    buttonText: 'dashboard.congratulation_you_sold.button_text',
    imageSrc: SalesBackground3
  },
  [SALES_BANNER_STEPS.CONGRATULATION_YOU_NUMBER_SALES]: {
    title: 'dashboard.congratulation_your_number_sales.title',
    description: 'dashboard.congratulation_you_sold.description',
    buttonText: 'dashboard.congratulation_you_sold.button_text',
    imageSrc: SalesBackground3
  }
};

const PLUS_ACCESS_MAX_MEMBERS = 3;

const BANNERS = {
  MARKETING_BANNER: 'MARKETING_BANNER',
  CLUB_SALES_PLUS_ACCESS: 'CLUB_SALES_PLUS_ACCESS'
};

const CURRENT_BANNER = BANNERS.CLUB_SALES_PLUS_ACCESS;

export {
  STATIC_LINKS,
  SALES_BANNER_STEPS,
  SALES_BANNER,
  BLOG_LANGUAGES,
  FAQ_LANGUAGES,
  MEMBERS_AREA_POST_ID,
  HOTMART_BLOG_API,
  PLUS_ACCESS_MAX_MEMBERS,
  BANNERS,
  CURRENT_BANNER
};
